import { db } from '@/components/Firebase_Conn'
import { auth } from '@/components/Firebase_Conn'
import router from '../../router.js'

const state = {
  userUid: '',
  logged: '',
  userProfile: {},
  userDettails: {}
}

const mutations = {
  setLoggedState (state, bool) {
    state.logged = bool
  },
  setUserUid (state, string) {
    state.userUid = string
  },
  setUserProfile (state, obj) {
    state.userProfile = obj
  },
  setUserDettails (state, obj) {
    state.userUid = obj.uid
    state.userDettails = obj
  }
}

const actions = {
  logIn ({ commit, state }, { email, password }) {
    return new Promise((resolve, reject) => {
      auth.signInWithEmailAndPassword(email, password)
        .then((user) => {
          commit('setLoggedState', true)
          commit('setUserDettails', user)
          console.log(user)
          router.replace('ordini')
          resolve(user)
        })
        .catch((err) => {
          commit('setLoggedState', false)
          router.replace('login')
          reject(err)
        })
    })
  },
  getUserUid ({ commit, state }) {
    const uid = auth.currentUser.uid
    console.log(uid)
  },
  getUserProfile ({ commit, state }, uid) {
    console.log('controllo loop')
    return new Promise((resolve, reject) => {
      db.ref('userList/' + state.userUid + '/').once('value').then(function (snapshot) {
        resolve(snapshot.val())
      })
    })
  },
  logOut ({ commit, state }) {
    return new Promise((resolve, reject) => {
      auth.signOut()
        .then(() => {
          commit('setLoggedState', false)
          //router.replace('login')
          resolve()
        })
        .catch((err) => {
          commit('setLoggedState', false)
          reject(err)
        })
    })
  }
/*
  checkUserStatus ({ commit, state }) {
    return new Promise((resolve, reject) => {
      auth.onAuthStateChanged((user) => {
        if (user) {
          commit('setLoggedState', true)
          commit('setUserDettails', auth.currentUser)
          resolve('User uid loggend : --> ' + user.uid)
          //router.push('/ordini')
        } else {
          commit('setLoggedState', false)
          router.push('/login')
          // eslint-disable-next-line prefer-promise-reject-errors
          reject('User is not logged in.')
        }
      })
    })
  }*/
  /* sendPasswordResetEmail: function () {
    console.log('invio...')
    var self = this;
    this.reimposta = false;
    this.esito = 'Invio in corso...'
    auth.sendPasswordResetEmail(this.formData.email).then(function () {
      self.esito = 'Inviata';
    }).catch(function (_error) {
      // An error happened.
    })
  },
  sendEmailVerification: function () {
    console.log('invio...')
    var self = this;
    this.verifica = false;
    this.esito = 'Invio in corso...'
    auth.currentUser.sendEmailVerification().then(function () {
      self.esito = 'Inviata';
      auth.signOut();
      console.log('Inviata...')
    }).catch(function (_error) {
      // An error happened.
    })
  }*/
}

export default {
  namespaced: true,
  state,
  // getters,
  actions,
  mutations
}